<template>
    <v-list nav dense>
        <v-subheader class="pl-0">
            <v-hover v-slot:default="{ hover }">
                <v-btn small text color="grey darken-1" class="text-caption" @click="$emit('update:expanded', !expanded)">
                    SPACE
                    <v-icon v-if="hover" right small>{{ expanded ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                </v-btn>
            </v-hover>
        </v-subheader>
        <v-expand-transition>
            <div v-show="expanded">
                <SpaceMenu :collapsed="collapsed" :show-quick-actions="true" />

                <v-list-item
                    :class="{ 'ml-2 drawer-active-item': !collapsed }"
                    active-class="primary--text"
                    :to="{
                        name: 'space-instances',
                        params: { oid: $route.params.oid, sid: $route.params.sid, iid: $route.params.iid, snid: $route.params.snid },
                        query: $route.query
                    }">
                    <v-list-item-icon>
                        <v-tooltip right :disabled="!collapsed">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on">mdi-cube-outline</v-icon>
                            </template>
                            <span>Instances</span>
                        </v-tooltip>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title>Instances</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action v-if="isSpaceAdmin && !collapsed" class="my-0">
                        <AddInstanceDialog>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn text small class="px-2" min-width="0" v-bind="attrs" v-on="on" @click.stop.prevent>
                                    <v-icon small>mdi-plus</v-icon>
                                </v-btn>
                            </template>
                        </AddInstanceDialog>
                    </v-list-item-action>
                </v-list-item>
            </div>
        </v-expand-transition>
    </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

const SpaceMenu = () => import('@/components/SpaceMenu.vue')
const AddInstanceDialog = () => import('@/modules/space/components/TheSpaceAddInstanceDialog.vue')

export default {
    name: 'DrawerSpaceSection',
    components: {
        SpaceMenu,
        AddInstanceDialog
    },
    props: {
        collapsed: {
            type: Boolean,
            default: false
        },
        expanded: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        ...mapGetters('spaceStore', ['isSpaceAdmin'])
    }
}
</script>
